export const POS_HOLD_DOCK_ENABLED_KEY = "pos_hold_dock_enabled";
export const POS_HOLD_DOCK_PREFERENCE_EVENT = "pos-hold-dock-preference-changed";

export const readHoldDockPreference = (storage = localStorage) =>
  storage.getItem(POS_HOLD_DOCK_ENABLED_KEY) !== "false";

export const writeHoldDockPreference = (enabled, storage = localStorage) => {
  storage.setItem(POS_HOLD_DOCK_ENABLED_KEY, enabled ? "true" : "false");
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(POS_HOLD_DOCK_PREFERENCE_EVENT));
  }
};
